/*
  Состояния лепестков веера (KanameMark petals). Лепесток k — на k·60° от 6 часов по часовой стрелке.
  Пластина твёрдая (R41): у неё есть только поза и прозрачность.
  - on — раскрыт на своём месте;
  - off — сложен за соседа (на шаг раньше) и прозрачен, как в сложенном веере;
  - gap — пластины нет, на её месте пунктирный контур-призрак («не найдено»);
  - dim — пластина на месте, но погашена («нет доступа»).
  Место «слова» знака одно — лепесток GAP_PETAL на 12 часах.
*/

export type PetalState = 'on' | 'off' | 'gap' | 'dim';
export type Petals = readonly [PetalState, PetalState, PetalState, PetalState, PetalState, PetalState];

/** Лепесток на 12 часах — место «слова» знака: пропуск или погашенная пластина. */
export const GAP_PETAL = 3;

export const FAN_FULL: Petals = ['on', 'on', 'on', 'on', 'on', 'on'];
export const FAN_OFF: Petals = ['off', 'off', 'off', 'off', 'off', 'off'];
/** Не найдено: на 12 часах пластины нет, только пунктирный контур её места. */
export const FAN_MISSING: Petals = ['on', 'on', 'on', 'gap', 'on', 'on'];
/** Нет доступа: пластина на 12 часах на месте, но погашена. */
export const FAN_LOCKED: Petals = ['on', 'on', 'on', 'dim', 'on', 'on'];

/** Первые n лепестков раскрыты (от 6 часов по часовой), остальные сложены. */
export function fanOf(n: number): Petals {
  const s = (k: number): PetalState => (k < n ? 'on' : 'off');
  return [s(0), s(1), s(2), s(3), s(4), s(5)];
}

/**
 * Сколько лепестков показать за done из total шагов: шестой выходит только на «готово».
 * Для 6 шагов — 1…5 и 6 на «готово»; для 4 шагов — 2, 3, 4, затем 6.
 */
export function petalsFor(done: number, total: number): number {
  if (total <= 0 || done >= total) return 6;
  return Math.max(0, Math.min(5, Math.ceil((5 * done) / total)));
}

/** Веер симметричен — все пластины раскрыты или все сложены: его можно поворачивать на лепесток. */
export function isWhole(p: Petals): boolean {
  return p.every((s) => s === 'on') || p.every((s) => s === 'off');
}
